<template>
  <div>
    <vs-row>
      <vs-col vs-align="left" vs-w="2">
        <vs-row>
          <vs-col vs-type="flex" vs-align="flex-end" vs-justify="flex-end" vs-w="12" class="px-0 mt-4">
            <vx-tooltip text="Add new" v-if="listTreatmentProcedure.length == 0">
            <vs-button size="default" class="mr-2" color="success" icon-pack="feather" icon="icon-plus" @click="addNew()"></vs-button>
            </vx-tooltip>
            <downloadexcel
                v-if="listTreatmentProcedure.length > 0"
                class   = "btn btn-default"
                :data   = "listTreatmentProcedure"
                worksheet = "Cytosponge"
                :name    = "item.delta_case_id + '-cytosponge.xls'">
              <vx-tooltip text="Download excel">
              <vs-button size="default" class="mr-2" color="primary" icon-pack="feather" icon="icon-download"></vs-button>
              </vx-tooltip>
            </downloadexcel>
          </vs-col>
        </vs-row>
        <table style="width:100%" v-if="listTreatmentProcedure.length > 0">
          <tr
            :class="{ activeDate: selectedTreatmentProcedure.delta_cytosponge_id==treatmentProcedure.delta_cytosponge_id }"
            v-for="treatmentProcedure in listTreatmentProcedure"
            :key="treatmentProcedure.delta_cytosponge_id"
            @click="
            selectedTreatmentProcedure=treatmentProcedure;
            // selectedTreatmentProcedure.time_clinic_start = {};
            // selectedTreatmentProcedure.time_clinic_end = {};
            selectedTreatmentProcedure.time_clinic_start.HH = this.selectedTreatmentProcedure.time_clinic_start_hour;
            selectedTreatmentProcedure.time_clinic_start.mm = this.selectedTreatmentProcedure.time_clinic_start_min;
            selectedTreatmentProcedure.time_clinic_end.HH = this.selectedTreatmentProcedure.time_clinic_end_hour;
            selectedTreatmentProcedure.time_clinic_end.mm = this.selectedTreatmentProcedure.time_clinic_end_min;

            medication_anti_coagulation = this.selectedTreatmentProcedure.medication_anti_coagulation;
            medication_other = this.selectedTreatmentProcedure.medication_other;
            listMedication = this.selectedTreatmentProcedure.listMedication;

            isEdit = false;isAddNew = false;
            isDelete = false;"
            style="cursor:pointer;">
            <td class="px-0">
              <vs-list class="px-0">
                <vs-list-item :title="treatmentProcedure.date_clinic" :subtitle="treatmentProcedure.cytosponge_swallow" class="px-0"></vs-list-item>
              </vs-list>
              <vs-divider class="py-0 mb-0 mt-0" />
            </td>
          </tr>
        </table>
      </vs-col>

      <vs-col vs-align="left" vs-w="7"><vs-card style='min-height:600px;margin-bottom:400px'>
        <vs-row v-if="listTreatmentProcedure.length == 0 && !isAddNew">
          <vs-col vs-align="left" vs-w="12">
            <vs-divider />
            No results found.
            <vs-divider />
          </vs-col>
        </vs-row>
        <template v-if="listTreatmentProcedure.length > 0 || isAddNew">
          <vs-row v-if="!isAddNew">
            <vs-col vs-align="left" vs-w="10">
              <h4 class="mt-4">
                {{selectedTreatmentProcedure.date_clinic}} | {{selectedTreatmentProcedure.cytosponge_swallow}}
              </h4>
            </vs-col>
            <vs-col vs-w="2" vs-type="flex" vs-align="flex-end" vs-justify="flex-end" class="px-0">
              <vs-button color="success" class="mr-2" icon-pack="feather" icon="icon-plus" @click="addNew()"
                v-if="!isEdit && listTreatmentProcedure.length == 0"></vs-button>
              <vs-button size="default" class="mr-2" color="warning" icon-pack="feather" icon="icon-edit" @click="isEdit=true;"
                v-if="!isEdit && (selectedTreatmentProcedure.lock_action!='request_unlock' && selectedTreatmentProcedure.lock_action!='lock')"></vs-button>
            </vs-col>
          </vs-row>
          <vs-divider/>
          <template v-if="isDelete">
            <vs-card>
              <div>
                <h3>Are you sure you want to delete this record?</h3>
              </div>
              <div class="py-8">
                This will permanently delete this record from the database.
              </div>
              <div><table><tr>
                <td><vs-button color="danger" @click="deleteRecord()">Delete record</vs-button></td>
                <td><vs-button color="warning" @click="isDelete=false;">Cancel</vs-button></td>
              </tr></table></div>
            </vs-card>
          </template>
          <template v-else><!--NOT DELETE-->
            <template v-if="isAddNew">
              <vs-row>
                <vs-col vs-w="6" vs-type="flex" vs-align="flex-start" vs-justify="flex-start" class="px-0">
                  <vs-button color="success" icon-pack="feather" icon="icon-save" @click="saveAddNew()"></vs-button>
                </vs-col>
                <vs-col vs-w="6" vs-type="flex" vs-align="flex-end" vs-justify="flex-end" class="px-0">
                  <vs-button color="warning" icon-pack="feather" icon="icon-slash" @click="getRecords(item.delta_case_id)"></vs-button>
                </vs-col>
              </vs-row>
              <vs-divider/>
            </template>
            <template v-else-if="isEdit">
              <vs-row>
                <vs-col vs-w="4" vs-type="flex" vs-align="flex-start" vs-justify="flex-start" class="px-0">
                  <vs-button size="default" class="mr-2" color="success" icon-pack="feather" icon="icon-save" @click="saveChanges()"></vs-button>
                </vs-col>
                <vs-col vs-w="4" vs-type="flex" vs-align="center" vs-justify="center" class="px-0">
                  <vs-button size="default" color="danger" icon-pack="feather" icon="icon-trash" @click="isDelete=true" v-if="!isAddNew"></vs-button>
                </vs-col>
                <vs-col vs-w="4" vs-type="flex" vs-align="flex-end" vs-justify="flex-end" class="px-0">
                  <vs-button size="default" class="mr-2" color="warning" icon-pack="feather" icon="icon-slash" @click="getRecords(item.delta_case_id)"></vs-button>
                </vs-col>
              </vs-row>
              <vs-divider />
            </template>

            <vs-row>
              <vs-col vs-align="left" vs-w="12">
                <vs-list>
                <!--- Cytosponge --->
                <vs-list-header title="Cytosponge procedure" icon-pack="feather" icon="icon-git-pull-request"></vs-list-header>
                <vs-list-item title="Date"
                  :subtitle="selectedTreatmentProcedure.date_clinic">
                  <datepicker
                    placeholder="Select Date"
                    v-if="isEdit"
                    :value="selectedTreatmentProcedure.date_clinic"
                    format="yyyy-MM-dd"
                    @selected="formatDateClinic"
                    v-validate="'required'"
                    name="date_clinic"></datepicker>
                  <span class="text-danger text-sm" v-show="errors.has('date_clinic')">{{ errors.first('date_clinic') }}</span>
                </vs-list-item>
                <vs-list-item title="Appointment start time"
                  :subtitle="selectedTreatmentProcedure.time_clinic_start ? (selectedTreatmentProcedure.time_clinic_start.HH + ':' + selectedTreatmentProcedure.time_clinic_start.mm) : ''">
                  <vue-timepicker manual-input v-model="selectedTreatmentProcedure.time_clinic_start"
                    name="time_clinic_start"
                    v-if="isEdit"
                    v-validate="'required'"></vue-timepicker>
                  <div class="text-danger text-sm" v-show="errors.has('time_clinic_start')">{{ errors.first('time_clinic_start') }}</div>
                </vs-list-item>
                <vs-list-item title="Cytosponge swallow" :subtitle="selectedTreatmentProcedure.cytosponge_swallow">
                  <v-select
                    v-if="isEdit"
                    v-model="selectedTreatmentProcedure.cytosponge_swallow"
                    :options="[
                      'First attempt',
                      'Second attempt',
                      'Third attempt',
                      'Unable to swallow',
                    ]"></v-select>
                </vs-list-item>
                <vs-list-item title="Device lot number" :subtitle="selectedTreatmentProcedure.cytosponge_device_lot_number">
                  <vs-input v-if="isEdit" name="cytosponge_device_lot_number" v-model="selectedTreatmentProcedure.cytosponge_device_lot_number" />
                </vs-list-item>
                <vs-list-item title="Device pot number" :subtitle="selectedTreatmentProcedure.cytosponge_device_pot_number">
                  <vs-input v-if="isEdit" name="cytosponge_device_pot_number" v-model="selectedTreatmentProcedure.cytosponge_device_pot_number" />
                </vs-list-item>
                <vs-list-header title="Device issues" icon-pack="feather" icon="icon-git-pull-request"></vs-list-header>
                <vs-list-item title="Device fault detected before use" :subtitle="selectedTreatmentProcedure.cytosponge_device_failure">
                  <v-select
                    v-if="isEdit"
                    v-model="selectedTreatmentProcedure.cytosponge_device_failure"
                    :options="[
                      'None',
                      'Capsule cracked',
                      'Packaging not sealed',
                      'Broken string',
                      'Other',
                    ]"></v-select>
                  <vs-input
                    v-validate="selectedTreatmentProcedure.cytosponge_device_failure=='Other'?'required':null"
                    v-if="isEdit && selectedTreatmentProcedure.cytosponge_device_failure=='Other'"
                    v-model="selectedTreatmentProcedure.cytosponge_device_failure_other"
                    name="cytosponge_device_failure_other" />
                </vs-list-item>
                <vs-list-item title="Adverse event" :subtitle="(selectedTreatmentProcedure.cytosponge_device_adverse_failure=='Other')?selectedTreatmentProcedure.cytosponge_device_issue_other:selectedTreatmentProcedure.cytosponge_device_adverse_failure">
                  <v-select
                    v-if="isEdit"
                    v-model="selectedTreatmentProcedure.cytosponge_device_adverse_failure"
                    :options="[
                      'None',
                      'Detachment',
                      'Bleeding on withdrawal',
                      'Other',
                    ]"></v-select>
                  <vs-input
                    v-validate="selectedTreatmentProcedure.cytosponge_device_adverse_failure=='Other'?'required':null"
                    v-if="isEdit && selectedTreatmentProcedure.cytosponge_device_adverse_failure=='Other'"
                    v-model="selectedTreatmentProcedure.cytosponge_device_issue_other"
                    name="cytosponge_device_issue_other" />
                </vs-list-item>
                <vs-list-header title="Local anaesthetic" icon-pack="feather" icon="icon-git-pull-request"></vs-list-header>
                <vs-list-item title="Was local anaesthetic used?" :subtitle="selectedTreatmentProcedure.local_anaesthetic_used">
                  <v-select
                    v-if="isEdit"
                    @change="onChange($event)"
                    v-model="selectedTreatmentProcedure.local_anaesthetic_used"
                    :options="[
                      'None', 'Yes', 'No',
                    ]"></v-select>
                </vs-list-item>
                <vs-list-header title="Smoking" icon-pack="feather" icon="icon-git-pull-request"></vs-list-header>
                <vs-list-item title="Smoking status" :subtitle="selectedTreatmentProcedure.smoking_status">
                  <v-select
                    v-if="isEdit"
                    @change="onChange($event)"
                    v-model="selectedTreatmentProcedure.smoking_status"
                    :options="[
                      'None',
                      'Current',
                      'Past',
                      'Never',
                    ]"></v-select>
                </vs-list-item>
                <vs-list-header title="Low grade dysplasia" icon-pack="feather" icon="icon-git-pull-request"></vs-list-header>
                <vs-list-item title="Previous low grade dysplasia for known Barrett’s" :subtitle="selectedTreatmentProcedure.previous_lgd_known_barretts ? 'Yes' : 'No'">
                  <vs-checkbox
                    class="ml-0"
                    vs-value="1"
                    :disabled="isEdit ? false : true"
                    v-model="selectedTreatmentProcedure.previous_lgd_known_barretts">
                    Tick if 'Yes'
                  </vs-checkbox>
                </vs-list-item>

                <vs-list-header title="Anti-reflux medication" icon-pack="feather" icon="icon-git-pull-request"></vs-list-header>
                <vs-list-item title="Are you on any medication for heartburn?" :subtitle="selectedTreatmentProcedure.medication_heartburn">
                  <v-select
                    v-if="isEdit"
                    @change="onChange($event)"
                    v-model="selectedTreatmentProcedure.medication_heartburn"
                    :options="[
                      'None', 'Yes', 'No',
                    ]"></v-select>
                </vs-list-item>
                <vs-list-item
                  icon-pack="feather" icon="icon-corner-down-right"
                  title="Length of time" :subtitle="selectedTreatmentProcedure.medication_length_of_time">
                  <v-select
                    v-if="isEdit"
                    @change="onChange($event)"
                    v-model="selectedTreatmentProcedure.medication_length_of_time"
                    :options="[
                      'None',
                      '0-1 year',
                      '1-2 years',
                      '2-3 years',
                      '3-4 years',
                      '4-5 years',
                      '5-6 years',
                      '6+ years',
                    ]"></v-select>
                </vs-list-item>
              </vs-list>

              <!--Table-->
              <table style="width:100%" v-if="isEdit || selectedTreatmentProcedure.listMedication.length>0">
                <tr>
                  <th v-if="isEdit"></th>
                  <th>Medication name</th>
                  <th>Dose (mg)</th>
                  <th>OD/BD</th>
                </tr>
                <tr v-for="(itemMedication, itemMedicationIndex) in selectedTreatmentProcedure.listMedication" :key="itemMedicationIndex">
                  <td v-if="isEdit">
                    <vs-button v-if="isEdit" type="border" icon-pack="feather" icon="icon-trash" @click="selectedTreatmentProcedure.listMedication.splice(itemMedicationIndex, 1);$forceUpdate()"></vs-button>
                  </td>
                  <td>
                    <template v-if="isEdit">
                      <v-select
                        v-if="isEdit"
                        @change="onChange($event)"
                        v-model="itemMedication.medication_heartburn_name"
                        :options="[
                          'Omeprazole',
                          'Cimetidine',
                          'Domperidone',
                          'Esomeprazole (Nexium)',
                          'Gaviscon',
                          'Lansoprazole (Zoton)',
                          'Maalox',
                          'Maxolon',
                          'Omeprazole (Losec)',
                          'Pantoprazole (Protium)',
                          'Rabeprazole (Pariet)',
                          'Ranitidine',
                          'Rennies',
                          'Other',
                        ]"></v-select>
                      <span class="text-danger text-sm" v-show="errors.has('medication_name_'+itemMedicationIndex)">{{ errors.first('medication_name_'+itemMedicationIndex) }}</span>
                      <vs-input
                        @change="onChange($event)"
                        v-validate="itemMedication.medication_heartburn_name=='Other'?'required':null"
                        v-if="isEdit && itemMedication.medication_heartburn_name=='Other'"
                        v-model="itemMedication.medication_heartburn_name_other"
                        :name="'medication_name_other_'+itemMedicationIndex" />
                      <span class="text-danger text-sm" v-show="errors.has('medication_name_other_'+itemMedicationIndex)">{{ errors.first('medication_name_other_'+itemMedicationIndex) }}</span>
                    </template>
                    <template v-else>
                      {{itemMedication.medication_heartburn_name}}
                      {{itemMedication.medication_heartburn_name_other}}
                    </template>
                  </td>
                  <td>
                    <template v-if="isEdit">
                      <vs-input-number @change="onChange($event)" style="width:100px" v-model="itemMedication.medication_heartburn_dose" />
                    </template>
                    <template v-else>
                      {{itemMedication.medication_heartburn_dose}}
                    </template>
                  </td>
                  <td>
                    <template v-if="isEdit">
                      <v-select
                        @change="onChange($event)"
                        v-if="isEdit"
                        style="min-width:60px"
                        v-model="itemMedication.medication_heartburn_odbd"
                        :options="['OD', 'BD', 'TDS', 'PRN']"></v-select>
                    </template>
                    <template v-else>
                      {{itemMedication.medication_heartburn_odbd}}
                    </template>
                  </td>
                </tr>
                <tr v-if="isEdit">
                  <td><vs-button color="success" class="mr-2" icon-pack="feather" icon="icon-plus" type="border"
                    @click="addRowlistMedication();" v-if="isEdit"></vs-button></td>
                </tr>
              </table>
              <vs-list>
              <vs-list-header title="Other medications" icon-pack="feather" icon="icon-git-pull-request"></vs-list-header>
              <vs-list-item
                title="Other medications"
                :subtitle="selectedTreatmentProcedure.medication_other">
                <v-select
                  v-if="isEdit"
                  @change="onChange($event)"
                  v-model="selectedTreatmentProcedure.medication_other"
                  multiple
                  :options="[
                    'None',
                    'Asthma inhalers',
                    'Aspirin or NSAIDS',
                  ]"></v-select>
              </vs-list-item>
            </vs-list>
            <table>
              <tr>
                <th colspan="2">Medication</th>
                <th>Dosing</th>
                <th>Duration of use</th>
              </tr>
              <tr>
                <td>Acid suppressant therapy</td>
                <td>
                <v-select
                  style="min-width:120px"
                  :disabled="!isEdit"
                  @change="onChange($event)"
                  v-model="selectedTreatmentProcedure.om_acid_suppress_therapy_medication"
                  :options="[
                    'Proton-pump inhibitors',
                    'H2RA antagonists',
                    'Others',
                  ]"></v-select>
                </td>
                <td><v-select
                  style="min-width:120px"
                  :disabled="!isEdit"
                  @change="onChange($event)"
                  v-model="selectedTreatmentProcedure.om_acid_suppress_therapy_dose"
                  :options="['OD', 'BD', 'TDS', 'PRN', 'Never used']"></v-select></td>
                <td>
                <v-select
                  style="min-width:130px"
                  :disabled="!isEdit"
                  @change="onChange($event)"
                  v-model="selectedTreatmentProcedure.om_acid_suppress_therapy_duration"
                  :options="[
                    '≥5 years',
                    '<5 years',
                  ]"></v-select></td>
                </td>
              </tr>
              <tr>
                <td colspan="2">Aspirin</td>
                <td><v-select
                  style="min-width:120px"
                  :disabled="!isEdit"
                  @change="onChange($event)"
                  v-model="selectedTreatmentProcedure.om_aspirin_dose"
                  :options="['OD', 'BD', 'TDS', 'PRN', 'Never used']"></v-select></td>
                <td>
                <v-select
                  style="min-width:130px"
                  :disabled="!isEdit"
                  @change="onChange($event)"
                  v-model="selectedTreatmentProcedure.om_aspirin_duration"
                  :options="[
                    '≥5 years',
                    '<5 years',
                  ]"></v-select></td>
                </td>
              </tr>
              <tr>
                <td colspan="2">Non-aspirin NSAIDS</td>
                <td><v-select
                  style="min-width:120px"
                  :disabled="!isEdit"
                  @change="onChange($event)"
                  v-model="selectedTreatmentProcedure.om_non_asp_nsaids_dose"
                  :options="['OD', 'BD', 'TDS', 'PRN', 'Never used']"></v-select></td>
                <td>
                <v-select
                  style="min-width:130px"
                  :disabled="!isEdit"
                  @change="onChange($event)"
                  v-model="selectedTreatmentProcedure.om_non_asp_nsaids_duration"
                  :options="[
                    '≥5 years',
                    '<5 years',
                  ]"></v-select></td>
                </td>
              </tr>
              <tr>
                <td colspan="2">Statin</td>
                <td><v-select
                  style="min-width:120px"
                  :disabled="!isEdit"
                  @change="onChange($event)"
                  v-model="selectedTreatmentProcedure.om_statis_dose"
                  :options="['OD', 'BD', 'TDS', 'PRN', 'Never used']"></v-select></td>
                <td>
                <v-select
                  style="min-width:130px"
                  :disabled="!isEdit"
                  @change="onChange($event)"
                  v-model="selectedTreatmentProcedure.om_statins_duration"
                  :options="[
                    '≥5 years',
                    '<5 years',
                  ]"></v-select></td>
                </td>
              </tr>
            </table>
            <vs-list>
              <vs-list-header title="Anti-coagulation/Anti-platlet medication" icon-pack="feather" icon="icon-git-pull-request"></vs-list-header>
              <vs-list-item
                title="Anti-coagulation/Anti-platlet medication"
                :subtitle="selectedTreatmentProcedure.medication_anti_coagulation">
                <v-select
                  v-if="isEdit"
                  v-model="selectedTreatmentProcedure.medication_anti_coagulation"
                  @change="onChange($event)"
                  multiple
                  :options="[
                    'None',
                    'Warfarin',
                    'Clopridogrel',
                    'Apixiban',
                    'Other',
                  ]"></v-select>
              </vs-list-item>
              <vs-list-item
                title="Other"
                v-if="selectedTreatmentProcedure.medication_anti_coagulation.includes('Other')"
                icon-pack="feather" icon="icon-corner-down-right"
                :subtitle="selectedTreatmentProcedure.medication_anti_coagulation_other">
                <vs-input
                  v-if="isEdit"
                  v-model="selectedTreatmentProcedure.medication_anti_coagulation_other"
                  name="medication_anti_coagulation_other" />
              </vs-list-item>
              <vs-list-header title="Acceptability" icon-pack="feather" icon="icon-git-pull-request"></vs-list-header>
              <vs-list-item
                title="Would you be willing to have the cytosponge procedure again in the future, if it was recommended by your doctor?"
                :subtitle="selectedTreatmentProcedure.acceptability_willing_again">
                <v-select
                  v-if="isEdit"
                  v-model="selectedTreatmentProcedure.acceptability_willing_again"
                  :options="[
                    'None',
                    'Yes, definitely',
                    'Yes, probably',
                    'No, probably not',
                    'No, definitely not',
                    'Unsure',
                  ]"></v-select>
              </vs-list-item>
              <vs-list-item
                icon-pack="feather" icon="icon-corner-down-right"
                title="Comment"
                :subtitle="selectedTreatmentProcedure.acceptability_willing_again_comment">
                <vs-input
                  v-if="isEdit"
                  v-model="selectedTreatmentProcedure.acceptability_willing_again_comment"
                  name="acceptability_willing_again_comment" />
              </vs-list-item>
              <vs-list-item
                title="How acceptable did you find the cytosponge procedure?"
                :subtitle="selectedTreatmentProcedure.acceptability">
                <v-select
                  v-if="isEdit"
                  v-model="selectedTreatmentProcedure.acceptability"
                  :options="[
                    'None',
                    'Completely acceptable',
                    'Acceptable',
                    'Unacceptable',
                    'Completely unacceptable',
                  ]"></v-select>
              </vs-list-item>
              <vs-list-item
                icon-pack="feather" icon="icon-corner-down-right"
                title="Comment"
                :subtitle="selectedTreatmentProcedure.acceptability_comment">
                <vs-input
                  v-if="isEdit"
                  v-model="selectedTreatmentProcedure.acceptability_comment"
                  name="acceptability_comment" />
              </vs-list-item>


                <vs-list-header title="Appointment" icon-pack="feather" icon="icon-git-pull-request"></vs-list-header>
                <vs-list-item title="Appointment end time"
                  :subtitle="selectedTreatmentProcedure.time_clinic_end ? (selectedTreatmentProcedure.time_clinic_end.HH + ':' + selectedTreatmentProcedure.time_clinic_end.mm) : ''">
                  <vue-timepicker
                    manual-input
                    name="time_clinic_end"
                    v-if="isEdit"
                    v-validate="'required'"
                    v-model="selectedTreatmentProcedure.time_clinic_end"></vue-timepicker>
                  <div class="text-danger text-sm" v-show="errors.has('time_clinic_end')">{{ errors.first('time_clinic_end') }}</div>
                </vs-list-item>
                <vs-list-item title="Nurse"
                  :subtitle="selectedTreatmentProcedure.nurse_clinic">
                  <!--
                  <vs-input
                    v-if="isEdit"
                    v-model="selectedTreatmentProcedure.nurse_clinic" name="nurse_clinic" />
                  <span class="text-danger text-sm" v-show="errors.has('nurse_clinic')">{{ errors.first('date_clinic') }}</span>


                  <v-select
                    v-if="isEdit"
                    taggable
                    @change="onChange($event)"
                    v-model="selectedTreatmentProcedure.nurse_clinic"
                    :options="listNurseCall"></v-select>
                  -->
                  <v-select
                    v-if="isEdit"
                    taggable
                    v-model="selectedTreatmentProcedure.nurse_clinic"
                    :options="listNurseCall"></v-select>
                </vs-list-item>

                <!--- End: Cytosponge -->
                </vs-list>
              </vs-col>
            </vs-row>
            <vs-divider/>

          </template>
        </template>
      </vs-card></vs-col>
      <vs-col vs-align="left" vs-w="3" v-if="listTreatmentProcedure.length>0 && !isAddNew">
        <!-- Lock/Unlock -->
        <!-- Hide lock for now -->
        <vs-card>
          <vs-list>
            <vs-list-header title="Lock" icon-pack="feather" icon="icon-git-pull-request"></vs-list-header>
            <vs-list-item title="Status"
              :subtitle="selectedTreatmentProcedure.lock_status">
            </vs-list-item>
          </vs-list>
          <!-- lock, request_unlock, unlock -->
          <template v-if="selectedTreatmentProcedure.lock_action=='lock'">
            <vs-button size="default" class="mr-2" color="warning" icon-pack="feather" icon="icon-unlock" @click="lockRequestUnlock()">Request unlock</vs-button>
          </template>
          <template v-else-if="selectedTreatmentProcedure.lock_action=='request_unlock' && isAdmin">
            <vs-button size="default" class="mr-2" color="success" icon-pack="feather" icon="icon-unlock" @click="lockUnlock()">Unlock</vs-button>
          </template>
          <template v-else-if="selectedTreatmentProcedure.lock_action=='request_unlock' && !isAdmin">
            <vs-button size="default" class="mr-2" disabled icon-pack="feather" icon="icon-unlock">Pending unlock</vs-button>
          </template>
          <template v-else>
            <vs-button size="default" class="mr-2" color="danger" icon-pack="feather" icon="icon-lock" @click="lockLock()">Lock</vs-button>
          </template>
        </vs-card>
        <!-- END: Lock/Unlock -->
        <vs-card>
        <vs-list>
          <vs-list-header title="Audit" icon-pack="feather" icon="icon-git-pull-request"></vs-list-header>
          <vs-list-item title="Created"
            :subtitle="selectedTreatmentProcedure.date_created">
          </vs-list-item>
          <vs-list-item title="Last updated"
            :subtitle="selectedTreatmentProcedure.date_updated">
          </vs-list-item>
        </vs-list>
        </vs-card>
        <!-- Full history -->
        <vs-card>
          <vs-list-header title="History" icon-pack="feather" icon="icon-git-pull-request"></vs-list-header>
          <vs-list-item
            v-for="item in selectedTreatmentProcedure.listCRFHistory" :key="item.date_created"
            :title="item.date_created"
            :subtitle="item.action + ' (' + item.user_name + ')'"></vs-list-item>
        </vs-card>
        <!-- END: Full history -->
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
import { API_LOCATION } from '@/config/config';
import axios from 'axios';
import downloadexcel from "vue-json-excel";
import Nl2br from 'vue-nl2br';
import Datepicker from 'vuejs-datepicker';
import VueTimepicker from 'vue2-timepicker';

export default{
	data() {
		return {
      isAdmin: localStorage.getItem('isAdmin'),
      listCytosponge: [],
      listTreatmentProcedure: [],
      listNurseCall: [],
      selectedTreatmentProcedure: {
        listMedication: [
        ],
        _cytosponge_swallow: '',
        _cytosponge_device_lot_number: '',
        _cytosponge_device_pot_number: '',
        _cytosponge_device_failure: '',
        _cytosponge_device_adverse_failure: '',
        _cytosponge_device_issue_other: '',
        _medication_heartburn: '',
        _medication_length_of_time: '',
        _medication_details: '',
        _medication_details_other: '',
        _date_clinic: '',
        _time_clinic_start_hour: '',
        _time_clinic_start_min: '',
        _time_clinic_end_hour: '',
        _time_clinic_end_min: '',
        _nurse_clinic: '',
        _acceptability_willing_again: '',
        _acceptability_willing_again_comment: '',
        _acceptability: '',
        _acceptability_comment: '',
        _local_anaesthetic_used: '',
      },
      isEdit: false,
      isAddNew: false,
      isDelete: false,
      isProcessing: false,
      listEndoscopy: [],
      listTreatment: [],
      listCytospongeOperator: [],
      listComplication: [],
      listSurgicalTheatre: [],
      listNeoadjuvantTreatment: [],
      listStagingSite: [],
      listCellDifferentiation: [],
      listProcedure: [],
      listAblationDevice: [
        { device_id: 'Halo 360', device_name: 'Halo 360' },
        { device_id: 'Halo 360 express', device_name: 'Halo 360 express' },
        { device_id: 'Halo 90', device_name: 'Halo 90' },
        { device_id: 'Halo 90 ultra', device_name: 'Halo 90 ultra' },
        { device_id: 'Halo 60', device_name: 'Halo 60' },
        { device_id: 'Halo TTS', device_name: 'Halo TTS' },
      ],
      listAblationResult: [
        'Good', 'Moderate', 'Poor'
      ],
      listAblationType: [],
      listResection: [],
      listEMRResection: [],
      listEMRResectionMethod: [
        { method_id:'Captivator', method_name:'Captivator' },
        { method_id:'Duette', method_name:'Duette' },
        { method_id:'Cap EMR', method_name:'Cap EMR' },
      ],

      listPatientCytospongeAblationAPCLocation: [],
      listPatientCytospongeResectionTreatmentComplication: [],
      listPatientCytospongeResectionESDKnife: [],
      listMedication: [],

      medication_anti_coagulation: [],
      medication_other: [],
		}
	},
  components: {
    Nl2br,
    downloadexcel,
    Datepicker,
    VueTimepicker,
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    delta_case_id: {
      type: Number,
      required: false
    },
  },
  watch: {
    'selectedTreatmentProcedure.endoscopy_id': function() {
      if(this.selectedTreatmentProcedure.endoscopy_id) {
        var that = this;

        this.listEndoscopy.forEach(itemEndoscopy => {
          if(itemEndoscopy.endoscopy_id==that.selectedTreatmentProcedure.endoscopy_id) {
            that.selectedTreatmentProcedure.date_cytosponge = itemEndoscopy.endoscopydate;
          }
        });
      }
    }
  },
  methods: {
    onChange(event) {
      this.$forceUpdate();
    },
    lockLock() {
      let _params = {
        "_delta_case_id": this.item.delta_case_id,
        "_crf_id": this.selectedTreatmentProcedure.delta_cytosponge_id,
        "_crf_name": 'delta_cytosponge',
      };

      axios.post(API_LOCATION + '/rpc/function_delta_lock_crf', _params, {
        headers: { Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('user')).token }
      }).then(response => {
        this.isAddNew = false;
        this.isEdit = false;

        // Refresh
        this.getRecords(this.item.delta_case_id);
        this.isProcessing = false;
      });
    },
    lockUnlock() {
      let _params = {
        "_delta_case_id": this.item.delta_case_id,
        "_crf_id": this.selectedTreatmentProcedure.delta_cytosponge_id,
        "_crf_name": 'delta_cytosponge',
      };

      axios.post(API_LOCATION + '/rpc/function_delta_unlock_crf', _params, {
        headers: { Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('user')).token }
      }).then(response => {
        this.isAddNew = false;
        this.isEdit = false;

        // Refresh
        this.getRecords(this.item.delta_case_id);
        this.isProcessing = false;
      });
    },
    lockRequestUnlock() {
      let _params = {
        "_delta_case_id": this.item.delta_case_id,
        "_crf_id": this.selectedTreatmentProcedure.delta_cytosponge_id,
        "_crf_name": 'delta_cytosponge',
      };

      axios.post(API_LOCATION + '/rpc/function_delta_request_unlock_crf', _params, {
        headers: { Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('user')).token }
      }).then(response => {
        this.isAddNew = false;
        this.isEdit = false;

        // Refresh
        this.getRecords(this.item.delta_case_id);
        this.isProcessing = false;
      });
    },
    getRecords(delta_case_id) {
      this.selectedTreatmentProcedure = {};
      this.isEdit = false;
      this.isAddNew = false;
      this.isDelete = false;

      axios.get(API_LOCATION + '/view_delta_cytosponge?delta_case_id=eq.' + delta_case_id +'&order=date_clinic.desc', {
      // axios.get(API_LOCATION + '/delta_cytosponge?delta_case_id=eq.' + delta_case_id, {
        headers: { Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('user')).token }
      } ).then(response => {
        if (response.data) {
          // Get nurses
          axios.get(API_LOCATION + '/view_delta_site_nurse_call_clinic?delta_case_id=eq.' + delta_case_id, {
            headers: { Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('user')).token }
          }).then(response => {
            if (response.data) {
              // this.listNurseCall = response.data;
              this.listNurseCall = response.data.map(a => a.nurse_name);
            }
          });

          this.listTreatmentProcedure = response.data;

          let index_cytosponge = 0;
          let delta_cytosponge_id_first;
          this.listTreatmentProcedure.forEach(itemCytosponge => {
            itemCytosponge.itemCytospongeEMRResection = [];
            itemCytosponge.listPatientCytospongeAblationAPCLocation = [];
            itemCytosponge.listMedication = [];
            let item_delta_cytosponge_id = itemCytosponge.delta_cytosponge_id;

            if (index_cytosponge==0) {
              delta_cytosponge_id_first = itemCytosponge.delta_cytosponge_id;
              console.log('SETTING delta_cytosponge_id_first' + itemCytosponge.delta_cytosponge_id);
            }
            index_cytosponge++;

            var that = this;

            axios.all([
              axios.get(API_LOCATION + '/view_delta_crf_history?crf_name=eq.delta_cytosponge&crf_id=eq.' + itemCytosponge.delta_cytosponge_id, {
                headers: { Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('user')).token }
              } ).then(response => {
                if (response.data) {
                  itemCytosponge.listCRFHistory = response.data;
                }
              }),
              axios.get(API_LOCATION + '/view_delta_cytosponge_medication_anti_coagulation_other?delta_cytosponge_id=eq.' + itemCytosponge.delta_cytosponge_id, {
                headers: { Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('user')).token }
              } ).then(response => {
                if (response.data && response.data.length > 0) {
                  itemCytosponge.medication_anti_coagulation_other = response.data[0].medication_anti_coagulation_other;
                }
              }),
              axios.get(API_LOCATION + '/view_delta_cytosponge_smoking_status?delta_cytosponge_id=eq.' + itemCytosponge.delta_cytosponge_id, {
                headers: { Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('user')).token }
              } ).then(response => {
                if (response.data && response.data.length > 0) {
                  itemCytosponge.smoking_status = response.data[0].smoking_status;
                }
              }),
              axios.get(API_LOCATION + '/view_delta_cytosponge_previous_lgd_known_barretts?delta_cytosponge_id=eq.' + itemCytosponge.delta_cytosponge_id, {
                headers: { Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('user')).token }
              } ).then(response => {
                if (response.data && response.data.length > 0) {
                  itemCytosponge.previous_lgd_known_barretts = response.data[0].previous_lgd_known_barretts;
                }
              }),
              axios.get(API_LOCATION + '/view_delta_cytosponge_local_anaesthetic_used?delta_cytosponge_id=eq.' + itemCytosponge.delta_cytosponge_id, {
                headers: { Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('user')).token }
              } ).then(response => {
                if (response.data && response.data.length > 0) {
                  itemCytosponge.local_anaesthetic_used = response.data[0].local_anaesthetic_used;
                  console.log(itemCytosponge.local_anaesthetic_used);
                }
              }),
              axios.get(API_LOCATION + '/view_delta_cytosponge_medication_anti_coagulation?delta_cytosponge_id=eq.' + itemCytosponge.delta_cytosponge_id, {
                headers: { Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('user')).token }
              } ).then(response => {
                if (response.data) {
                  itemCytosponge.medication_anti_coagulation = response.data.map(a => a.medication_anti_coagulation);
                }
              }),
              axios.get(API_LOCATION + '/view_delta_cytosponge_medication_other?delta_cytosponge_id=eq.' + itemCytosponge.delta_cytosponge_id, {
                headers: { Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('user')).token }
              } ).then(response => {
                if (response.data) {
                  itemCytosponge.medication_other = response.data.map(a => a.medication_other);
                }
              }),
              axios.get(API_LOCATION + '/delta_cytosponge_medication_heartburn?delta_cytosponge_id=eq.' + itemCytosponge.delta_cytosponge_id, {
                headers: { Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('user')).token }
              } ).then(response => {
                if (response.data) {
                  itemCytosponge.listMedication = response.data;
                }
              }),
            ])
            .then(axios.spread((...args) => {
              //Finished
              if (itemCytosponge.delta_cytosponge_id == delta_cytosponge_id_first) {
                that.selectedTreatmentProcedure = itemCytosponge;

                this.selectedTreatmentProcedure.time_clinic_start = {};
                this.selectedTreatmentProcedure.time_clinic_end = {};
                this.selectedTreatmentProcedure.time_clinic_start.HH = this.selectedTreatmentProcedure.time_clinic_start_hour;
                this.selectedTreatmentProcedure.time_clinic_start.mm = this.selectedTreatmentProcedure.time_clinic_start_min;
                this.selectedTreatmentProcedure.time_clinic_end.HH = this.selectedTreatmentProcedure.time_clinic_end_hour;
                this.selectedTreatmentProcedure.time_clinic_end.mm = this.selectedTreatmentProcedure.time_clinic_end_min;

                that.medication_anti_coagulation = this.selectedTreatmentProcedure.medication_anti_coagulation;
                that.medication_other = this.selectedTreatmentProcedure.medication_other;
                that.listMedication = this.selectedTreatmentProcedure.listMedication;
              }
            }));
          });
        }
      });

      // Load endoscopy separately
      /*
      axios.get(API_LOCATION + '/view_patient_endoscopy_full?delta_case_id=eq.' + delta_case_id + '&order=endoscopydate.desc', {
        headers: { Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('user')).token }
      } ).then(response => {
        if (response.data) {
          this.listEndoscopy = response.data;
        }
      });
      */
    },
    getOptions() {
      let paramOptions = [
        // { url: 'cytosponge_procedure', data: 'listProcedure', },
        // { url: 'ablation_type', data: 'listAblationType', },
        // { url: 'ablation_device', data: 'listAblationDevice', },
        // { url: 'cytosponge_resection', data: 'listResection', },
      ];

      // Populate parameters
      for (let i = 0; i < paramOptions.length; i++ ){
        let thisParamOption = paramOptions[i];

        axios.get(API_LOCATION + '/' + thisParamOption.url, {
          headers: { Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('user')).token }
        }).then(response => {
          if (response.data) {
            this[thisParamOption.data] = response.data;
          }
        });
      }// for
    },
    addNew() {
      this.isEdit = true;
      this.isAddNew = true;
      this.isDelete = false;

      this.selectedTreatmentProcedure = {};

      this.selectedTreatmentProcedure.medication_anti_coagulation = [];
      this.selectedTreatmentProcedure.medication_other = [];

      this.selectedTreatmentProcedure.time_clinic_start = {};
      this.selectedTreatmentProcedure.time_clinic_end = {};

      // Set to current time and date
      var currDate = new Date;
      var currMinutes = currDate.getMinutes().toString();
      currMinutes = ("0" + currMinutes).slice(-2);
      var currHour = currDate.getHours().toString();
      currHour = ("0" + currHour).slice(-2);

      if(!this.selectedTreatmentProcedure.time_clinic_start.HH && !this.selectedTreatmentProcedure.time_clinic_start.mm) {
        this.selectedTreatmentProcedure.time_clinic_start.HH = currHour;
        this.selectedTreatmentProcedure.time_clinic_start.mm = currMinutes;
        this.selectedTreatmentProcedure.time_clinic_end.HH = currHour;
        this.selectedTreatmentProcedure.time_clinic_end.mm = currMinutes;
      }

      // Set to current date
      this.selectedTreatmentProcedure.date_clinic = this.currFormattedDate();

      // Medication list
      this.selectedTreatmentProcedure.listMedication = [];
    },
    currFormattedDate() {
      // https://stackoverflow.com/questions/23593052/format-javascript-date-as-yyyy-mm-dd
      var d = new Date(),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;
      return [year, month, day].join('-');
    },
    addRowlistMedication() {
      this.selectedTreatmentProcedure.listMedication.push({});
      this.$forceUpdate();
    },
    saveAddNew() {
      if (!this.selectedTreatmentProcedure.date_cytosponge_formatted && this.selectedTreatmentProcedure.date_cytosponge != '') {
        let date_cytosponge = new Date(this.selectedTreatmentProcedure.date_cytosponge);
        this.formatSelectedDate(date_cytosponge);
      }

      let _params = {
        "_delta_case_id": this.item.delta_case_id,
        "_cytosponge_swallow": this.selectedTreatmentProcedure.cytosponge_swallow || '',
        "_cytosponge_device_lot_number": this.selectedTreatmentProcedure.cytosponge_device_lot_number || '',
        "_cytosponge_device_pot_number": this.selectedTreatmentProcedure.cytosponge_device_pot_number || '',
        "_cytosponge_device_failure": this.selectedTreatmentProcedure.cytosponge_device_failure || '',
        "_cytosponge_device_adverse_failure": this.selectedTreatmentProcedure.cytosponge_device_adverse_failure || '',
        "_cytosponge_device_issue_other": this.selectedTreatmentProcedure.cytosponge_device_issue_other || '',
        "_medication_heartburn": this.selectedTreatmentProcedure.medication_heartburn || '',
        "_medication_length_of_time": this.selectedTreatmentProcedure.medication_length_of_time || '',
        "_medication_details": this.selectedTreatmentProcedure.medication_details || '',
        "_medication_details_other": this.selectedTreatmentProcedure.medication_details_other || '',
        "_date_clinic": this.selectedTreatmentProcedure.date_clinic || '',
        "_time_clinic_start_hour": this.selectedTreatmentProcedure.time_clinic_start.HH || '',
        "_time_clinic_start_min": this.selectedTreatmentProcedure.time_clinic_start.mm || '',
        "_time_clinic_end_hour": this.selectedTreatmentProcedure.time_clinic_end.HH || '',
        "_time_clinic_end_min": this.selectedTreatmentProcedure.time_clinic_end.mm || '',
        "_nurse_clinic": this.selectedTreatmentProcedure.nurse_clinic || '',

        "_acceptability_willing_again": this.selectedTreatmentProcedure.acceptability_willing_again || '',
        "_acceptability_willing_again_comment": this.selectedTreatmentProcedure.acceptability_willing_again_comment || '',
        "_acceptability": this.selectedTreatmentProcedure.acceptability || '',
        "_acceptability_comment": this.selectedTreatmentProcedure.acceptability_comment || '',

        "_medication_anti_coagulation": this.medication_anti_coagulation,
        "_medication_other": this.medication_other,

        "_medication_heartburn_name": [],
        "_medication_heartburn_name_other": [],
        "_medication_heartburn_dose": [],
        "_medication_heartburn_odbd": [],

        "_smoking_status": this.selectedTreatmentProcedure.smoking_status || '',
        "_previous_lgd_known_barretts": this.selectedTreatmentProcedure.previous_lgd_known_barretts || '',
        "_local_anaesthetic_used": this.selectedTreatmentProcedure.local_anaesthetic_used || '',

        "_om_acid_suppress_therapy_medication" : this.selectedTreatmentProcedure.om_acid_suppress_therapy_medication || '',
        "_om_acid_suppress_therapy_dose" : this.selectedTreatmentProcedure.om_acid_suppress_therapy_dose || '',
        "_om_acid_suppress_therapy_duration" : this.selectedTreatmentProcedure.om_acid_suppress_therapy_duration || '',
        "_om_aspirin_dose" : this.selectedTreatmentProcedure.om_aspirin_dose || '',
        "_om_aspirin_duration" : this.selectedTreatmentProcedure.om_aspirin_duration || '',
        "_om_non_asp_nsaids_dose" : this.selectedTreatmentProcedure.om_non_asp_nsaids_dose || '',
        "_om_non_asp_nsaids_duration" : this.selectedTreatmentProcedure.om_non_asp_nsaids_duration || '',
        "_om_statis_dose" : this.selectedTreatmentProcedure.om_statis_dose || '',
        "_om_statins_duration" : this.selectedTreatmentProcedure.om_statins_duration || '',
      };

      // Anti-reflux medication
      for (let i = 0; i < this.listMedication.length; i++) {
        _params._medication_heartburn_name.push(this.listMedication[i].medication_heartburn_name);
        _params._medication_heartburn_name_other.push(this.listMedication[i].medication_heartburn_name_other);
        _params._medication_heartburn_dose.push(this.listMedication[i].medication_heartburn_dose);
        _params._medication_heartburn_odbd.push(this.listMedication[i].medication_heartburn_odbd);
      }

      this.$validator.validateAll().then(result => {
        if(result) {
          this.isProcessing = true;

          axios.post(API_LOCATION + '/rpc/function_insert_delta_cytosponge', _params, {
            headers: { Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('user')).token }
          }).then(response => {
            this.isAddNew = false;
            this.isEdit = false;

            // Refresh
            this.getRecords(this.item.delta_case_id);
            this.isProcessing = false;
          });
        }
      });
    },
    formatSelectedDate(selectedDate) {
      this.selectedTreatmentProcedure.date_cytosponge = selectedDate.getFullYear() + '-' +
        this.pad((selectedDate.getMonth() + 1))  + '-' + this.pad(selectedDate.getDate());

      //this.selectedTreatmentProcedure.date_cytosponge_formatted = this.pad(selectedDate.getDate()) + '/' +
      //  this.pad((selectedDate.getMonth() + 1))  + '/' + selectedDate.getFullYear();

      this.selectedTreatmentProcedure.date_cytosponge_formatted = this.selectedTreatmentProcedure.date_cytosponge;
    },
    pad(n) {
      return (n < 10) ? ("0" + n) : n;
    },
    formatDateClinic(selectedDate) {
      this.selectedTreatmentProcedure.date_clinic = selectedDate.getFullYear() + '-' +
        this.pad((selectedDate.getMonth() + 1))  + '-' + this.pad(selectedDate.getDate());
    },
    setCytospongeEndoscopyDate() {
      console.log('TEST');
    },
    saveChanges() {
      let _params = {
        "_delta_case_id": this.item.delta_case_id,
        "_delta_cytosponge_id": this.selectedTreatmentProcedure.delta_cytosponge_id,
        "_cytosponge_swallow": this.selectedTreatmentProcedure.cytosponge_swallow || '',
        "_cytosponge_device_lot_number": this.selectedTreatmentProcedure.cytosponge_device_lot_number || '',
        "_cytosponge_device_pot_number": this.selectedTreatmentProcedure.cytosponge_device_pot_number || '',
        "_cytosponge_device_failure": this.selectedTreatmentProcedure.cytosponge_device_failure || '',
        "_cytosponge_device_adverse_failure": this.selectedTreatmentProcedure.cytosponge_device_adverse_failure || '',
        "_cytosponge_device_issue_other": this.selectedTreatmentProcedure.cytosponge_device_issue_other || '',
        "_medication_heartburn": this.selectedTreatmentProcedure.medication_heartburn || '',
        "_medication_length_of_time": this.selectedTreatmentProcedure.medication_length_of_time || '',
        "_medication_details": this.selectedTreatmentProcedure.medication_details || '',
        "_medication_details_other": this.selectedTreatmentProcedure.medication_details_other || '',
        "_date_clinic": this.selectedTreatmentProcedure.date_clinic || '',
        "_time_clinic_start_hour": this.selectedTreatmentProcedure.time_clinic_start.HH || '',
        "_time_clinic_start_min": this.selectedTreatmentProcedure.time_clinic_start.mm || '',
        "_time_clinic_end_hour": this.selectedTreatmentProcedure.time_clinic_end.HH || '',
        "_time_clinic_end_min": this.selectedTreatmentProcedure.time_clinic_end.mm || '',
        "_nurse_clinic": this.selectedTreatmentProcedure.nurse_clinic || '',

        "_acceptability_willing_again": this.selectedTreatmentProcedure.acceptability_willing_again || '',
        "_acceptability_willing_again_comment": this.selectedTreatmentProcedure.acceptability_willing_again_comment || '',
        "_acceptability": this.selectedTreatmentProcedure.acceptability || '',
        "_acceptability_comment": this.selectedTreatmentProcedure.acceptability_comment || '',

        "_medication_anti_coagulation": this.selectedTreatmentProcedure.medication_anti_coagulation,
        "_medication_other": this.selectedTreatmentProcedure.medication_other,

        "_medication_heartburn_name": [],
        "_medication_heartburn_name_other": [],
        "_medication_heartburn_dose": [],
        "_medication_heartburn_odbd": [],

        "_smoking_status": this.selectedTreatmentProcedure.smoking_status || '',
        "_previous_lgd_known_barretts": this.selectedTreatmentProcedure.previous_lgd_known_barretts || '',
        "_local_anaesthetic_used": this.selectedTreatmentProcedure.local_anaesthetic_used || '',

        "_om_acid_suppress_therapy_medication" : this.selectedTreatmentProcedure.om_acid_suppress_therapy_medication || '',
        "_om_acid_suppress_therapy_dose" : this.selectedTreatmentProcedure.om_acid_suppress_therapy_dose || '',
        "_om_acid_suppress_therapy_duration" : this.selectedTreatmentProcedure.om_acid_suppress_therapy_duration || '',
        "_om_aspirin_dose" : this.selectedTreatmentProcedure.om_aspirin_dose || '',
        "_om_aspirin_duration" : this.selectedTreatmentProcedure.om_aspirin_duration || '',
        "_om_non_asp_nsaids_dose" : this.selectedTreatmentProcedure.om_non_asp_nsaids_dose || '',
        "_om_non_asp_nsaids_duration" : this.selectedTreatmentProcedure.om_non_asp_nsaids_duration || '',
        "_om_statis_dose" : this.selectedTreatmentProcedure.om_statis_dose || '',
        "_om_statins_duration" : this.selectedTreatmentProcedure.om_statins_duration || '',
      };

      // Anti-reflux medication
      for (let i = 0; i < this.listMedication.length; i++) {
        _params._medication_heartburn_name.push(this.listMedication[i].medication_heartburn_name);
        _params._medication_heartburn_name_other.push(this.listMedication[i].medication_heartburn_name_other);
        _params._medication_heartburn_dose.push(this.listMedication[i].medication_heartburn_dose);
        _params._medication_heartburn_odbd.push(this.listMedication[i].medication_heartburn_odbd);
      }

      this.$validator.validateAll().then(result => {
        if(result) {
          this.isProcessing = true;

          axios.post(API_LOCATION + '/rpc/function_update_delta_cytosponge', _params, {
            headers: { Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('user')).token }
          }).then(response => {
            this.isEdit = false;
            this.getRecords(this.item.delta_case_id);

            this.isProcessing = false;
          });
        }
      });
    },
    deleteRecord() {
      this.isProcessing = true;

      axios.post(API_LOCATION + '/rpc/function_delete_delta_cytosponge', {
        _delta_cytosponge_id: this.selectedTreatmentProcedure.delta_cytosponge_id,
        _delta_case_id: this.selectedTreatmentProcedure.delta_case_id,
      }, {
        headers: { Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('user')).token }
      }).then(response => {
        this.isEdit = false;
        this.isDelete = false;
        this.getRecords(this.item.delta_case_id);

        this.isProcessing = false;
      });
    },
    addRowListEMRResection() {
      this.listEMRResection.push({});
    }
  },
  mounted() {
    this.getOptions();

    // If prop delta_case_id is set
    if(this.delta_case_id) {
      this.getRecords(this.delta_case_id);
    }
  },
}
</script>
<style>
tr.activeDate, tr.activeDate h6 {
  color: rgb(115, 103, 240);
}
</style>
